import {
  DiscountType,
  AlertType,
  AlertDictionaryDiscountBookmark,
} from 'interfaces';
import { Dispatch } from 'redux';
import { setAlert, showAlert } from 'redux/modules/Alert/alert';
import {
  getAlertTitleDiscount,
  getAlertBodyTextDiscount,
} from 'view/molecules/Alert';

export const showSuccessAlert = ({
  dispatch,
  discountType,
  discountId,
  discountTitle,
  operation,
}: {
  dispatch: Dispatch;
  discountType: DiscountType;
  discountId?: number;
  discountTitle: string;
  operation: AlertDictionaryDiscountBookmark;
}) => {
  const alert = {
    type: AlertType.success,
    title: getAlertTitleDiscount({
      discountType,
      discountBookmark: operation,
    }),
    bodyText: getAlertBodyTextDiscount({
      discountType,
      discountBookmark: operation,
      discountId,
      discountTitle,
    }),
  };

  dispatch(setAlert(alert));

  dispatch(showAlert());
};
